/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import ViewModel from "../../ViewModels/ViewModel";
import FileUpload from "../FileUploadBase/FileUpload";
import ImageFileUploadInputProps from "./ImageFileUploadInputProps";
import ImageFileUploadInputState, { createInitialState } from "./ImageFileUploadInputState";

export default class ImageFileUploadInputModel extends ViewModel<ImageFileUploadInputState> {
    public constructor(private readonly _props: ImageFileUploadInputProps) {
        super({
            initialState: createInitialState(),
        });
    }

    public aendern = (dateien: FileUpload[]) => {
        this.setState((nextState) => {
            nextState.errors = [];
            nextState.errorResetFlag = !nextState.errorResetFlag;
        });
        this._props.onChange(dateien);
    }

    public fehlerSetzen = (message: string) => {
        this.setState((nextState) => nextState.errors = [message]);
    }
}
